var React = require('react');

function LogoMark (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M38.4 0c-21 0-38 17-38 38s17 38.1 38.1 38.1 38.1-17 38.1-38.1S59.4 0 38.4 0zm3.2 57.2c-.9 1-2.1 1.4-3.3 1.4-2 0-3.9-1.2-4.7-3.1L17.9 22.4h10.4L42.4 52c.2.6.4 1.2.5 1.8 0 1.3-.4 2.5-1.3 3.4zM57 29.6s0 .1 0 0L51.9 40c-.2.5-.9.5-1.1 0l-5.1-10.3v-.1c-.4-.8-.6-1.8-.6-2.7 0-3.4 2.8-6.3 6.3-6.3 3.4 0 6.3 2.8 6.3 6.3 0 1-.3 1.9-.7 2.7z"}));
}

LogoMark.defaultProps = {"width":"76","height":"76","viewBox":"0 0 76.1 76.1"};

module.exports = LogoMark;

LogoMark.default = LogoMark;
